module.exports = __webpack_public_path__ + "static/media/chapter_number_1.96b3d241.svg";